export default "__VITE_ASSET__C7K8Own$__"